import PropTypes from 'prop-types';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { defineMessages, injectIntl } from 'react-intl';
import _ from 'lodash';
import PlusIcon from '../icons/Plus';
import SearchIcon from '../icons/Search';
import style from './AutocompleteField.scss';
import localeMessages from '../../locale/messages';
import { compose } from 'redux';
import { withRtl } from '../../components/hoc';
import {customisedIntlFormatMessage} from '../../utils/helpers';

const messages = defineMessages({
  placeholder: {
    id: 'searchfield.input.placeholder',
    defaultMessage: 'Search for a program to add',
    description: 'Search placeholder',
  },
});

class AutocompleteField extends Component {
  static defaultProps = {
    showSearch: false,
    title: '',
  };

  static propTypes = {
    onChangeValue: PropTypes.func.isRequired,
    saveApplication: PropTypes.func.isRequired,
    onBlur: PropTypes.func.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    showSearch: PropTypes.bool,
    title: PropTypes.string,
  };

  static contextTypes = {
    intl: PropTypes.shape({}).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      focus: true,
      mouseover: true,
      selectedProgramId: null,
      // Adding an array to keep previously selected programs out of autocomplete
      selectedProgramList: [],
    };
  }

  componentDidMount() {
    this.searchInput.focus();
    if(this.props.user.isDR){
      this.call_autocomplete_api();
    }
  }

  handleFocus = () => {
    this.setState({ focus: true });
  };

  handleBlur = () => {
    const { onBlur } = this.props;
    this.setState({
      ...this.state,
      focus: false,
    });
    onBlur();
  };

  handleMouseOver = () => {
    this.setState({
      ...this.state,
      mouseover: true,
    });
  };

  handleMouseOut = () => {
    this.setState({
      ...this.state,
      mouseover: false,
    });
  };

  handleAutocompleteClick = ({ id, schoolId, schoolDbn, savedApplication }) => {
    if (this.state.selectedProgramId !== id) {
      const { saveApplication } = this.props;
      const { selectedProgramList } = this.state;
      saveApplication(id, schoolId, schoolDbn, savedApplication, '');
      selectedProgramList.push(id);

      this.setState({
        ...this.state,
        selectedProgramId: id,
        selectedProgramList,
      });
    }
  };

  handleAutocompletekeyDown = ({ event, id, schoolId, schoolDbn, savedApplication }) => {
    if (event.keyCode === 13 && this.state.selectedProgramId !== id) {
      const { saveApplication } = this.props;
      const { selectedProgramList } = this.state;
      saveApplication(id, schoolId, schoolDbn, savedApplication, '');
      selectedProgramList.push(id);

      this.setState({
        ...this.state,
        selectedProgramId: id,
        selectedProgramList,
      });
    }
  };

  call_autocomplete_api = () => {
    const onChangeValue = _.debounce(this.props.onChangeValue, 500);
    onChangeValue(null, document.getElementById('autocomplete_input_box').value);
  };

  renderOptions = () => {
    const { options, title } = this.props;
    const { selectedProgramList } = this.state;
    let optionsList = '';
    if (options.length) {
      optionsList = (
        <div className={style.autocomplete}>
          <div className={style.autocompleteTitle}>{title}</div>
          <ul>
            {options.map(option => {
              if (!selectedProgramList.includes(option.id)) {
                return (
                  <li
                    className={style.programAutocompleteListitem}
                    key={`programAutocomplete-${option.name}-${option.school_name}`}
                  >
                    <div
                      tabIndex="0"
                      role="button"
                      style={{ display: 'flex' }}
                      onClick={() =>
                        this.handleAutocompleteClick({
                          id: option.id,
                          schoolId: option.school_id,
                          schoolDbn: option.dbn,
                          savedApplication: false,
                        })
                      }
                      onKeyDown={event =>
                        this.handleAutocompletekeyDown({
                          event,
                          id: option.id,
                          schoolId: option.school_id,
                          schoolDbn: option.dbn,
                          savedApplication: false,
                        })
                      }
                    >
                      <div className={style.svgWrapper}>
                        <PlusIcon size={12} fill="#024cbc" />
                      </div>
                      <div>
                        <div className={style.programAutocompleteSchool}>{option.school_name}</div>
                        <div>{option.name}</div>
                      </div>
                    </div>
                  </li>
                );
              }
              return null;
            })}
          </ul>
        </div>
      );
    }
    return optionsList;
  };

  render() {
    const { showSearch, intl } = this.props;
    // adding debouncing to reduce API calls
    const onChangeValue = _.debounce(this.props.onChangeValue, 500);
    const { focus, mouseover } = this.state;
    return (
      <div className={style.root} onMouseEnter={this.handleMouseOver} onMouseLeave={this.handleMouseOut}>
        <input
          ref={input => {
            this.searchInput = input;
          }}
          className={style.input}
          type="search"
          id="autocomplete_input_box"
          placeholder={customisedIntlFormatMessage(intl, messages.placeholder)}
          onChange={event => onChangeValue(event, event.target.value)}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
          /* eslint-disable  jsx-a11y/no-autofocus */
          autoFocus={showSearch}
          aria-label={customisedIntlFormatMessage(intl, messages.placeholder)}
          defaultValue={this.props.user.isDR ? 'dream' : ''}
        />
        <button className={style.button} onClick={() => this.call_autocomplete_api()} aria-label={customisedIntlFormatMessage(intl, localeMessages.buttonSearch)}>
          <SearchIcon size={25} fill="#024cbc" />
        </button>
        {(focus || mouseover || this.props.user.isDR) && this.renderOptions()}
      </div>
    );
  }
}

export { AutocompleteField };
export default compose(
  //
  injectIntl,
  withRtl(style),
  withStyles(style),
)(AutocompleteField);
